module.exports = __webpack_public_path__ + "img/CardNFT06.c0328279.png";